import { Component, Vue } from 'vue-property-decorator';

import Chromosome from '@/components/chromosome/chromosome.vue';
import Navbar from '@/components/navbar/navbar.vue';
import Sidebar from '@/components/sidebar/sidebar.vue';
import { ComponentOptions } from 'vue';

@Component({
    components: {
        Chromosome,
        Navbar,
        Sidebar,
    },
    metaInfo() {
        return {
            titleTemplate: '%s - Chromosome 6 Project',
        };
    },
})
export default class App extends Vue {
    chromosome = false;
}
